/*
* 东风小学定制
* */

import { get, post, url } from '../../service/ApiDecorator'
class PatrolClass {
  // 授课老师
  @url('/v3/custom/sysdfdyxx/classroundtea/pageClassRoundTeacher')
  @get
  pageClassRoundTeacher() { }
  // 授课老师
  @url('/v3/listTeacherByAdminClassName')
  @get
  listTeacherByAdminClassName() { }

  // 巡课保存
  @url('/v3/custom/sysdfdyxx/classround/addOrUpdate')
  @post
  addOrUpdate() { }

  // 巡课记录
  @url('/v3/custom/sysdfdyxx/classround/pageClassRound')
  @get
  pageClassRound() { }

  // 巡课删除
  @url('/v3/custom/sysdfdyxx/classround/delById')
  @post
  delById() { }

  // 导出巡课
  @url('/v3/custom/sysdfdyxx/classround/exportData')
  @post
  exportData() { }

  // 删除
  @url('/v3/custom/sysdfdyxx/classroundtea/delById')
  @post
  classroundteaDelById() { }
  // 获取巡课班级
  @url('/v3/custom/sysdfdyxx/classroundtea/listClassRoundTeacherWithCommitFlag')
  @get
  listClassRoundTeacherWithCommitFlag() { }
}
export default new PatrolClass()
